import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setOpen(false);
    window.open(cat.url, '_blank', 'noopener');
  };

  return (
    <div className="relative w-full max-w-md mx-auto" ref={dropdownRef}>
      <label className="block text-sm font-medium text-foreground-700 mb-2 text-center">
        Browse Product Categories
      </label>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-3 px-5 py-3.5 rounded-xl bg-background-50 border border-background-300/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
      >
        <span className={`text-sm ${selected ? 'text-foreground-800 font-medium' : 'text-foreground-400'}`}>
          {selected || 'Select a category to shop...'}
        </span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className={`ri-arrow-down-s-line text-base text-foreground-500 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}></i>
        </div>
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden z-30 animate-scale-in max-h-[320px] overflow-y-auto">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => handleSelect(cat)}
              className="w-full flex items-center gap-3 px-5 py-3 text-left text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600 flex-shrink-0">
                <i className={`${cat.icon} text-sm`}></i>
              </div>
              <span className="font-medium">{cat.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}